import { useLanguage } from "../context/LanguageProvider";

export default function CityList({ city }) {
  const { t } = useLanguage();
  const formatPrice = (price) => {
    return new Intl.NumberFormat("fr", {
      style: "currency",
      currency: "MAD",
    }).format(price)
  }

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    })
  }

  return (
    <div className="group bg-white rounded-3xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-100 hover:border-[var(--color-primary-100)]">
      <div className="p-4  w-full">
        <div className="flex items-center">
          <div className="flex items-center justify-between gap-8 max-md:gap-3 w-[100%]">
            <div className="flex items-center gap-10 max-md:gap-3">
              <div className="w-10 h-10 bg-[var(--color-primary-500)] rounded-2xl flex items-center justify-center">
                <svg className="h-6 w-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                    d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                    d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 group-hover:text-[var(--color-primary-500)] transition-colors duration-300">
                {city.name}
              </h3>
            </div>

                {/* Prices */}
              <div className="grid xl:grid-cols-4 md:grid-cols-2 gap-10 gap-4 text-xs">
                <div>
                  <div className="text-gray-500 max-md:text-xs">{t('cities.shipping')}</div>
                  <div className="text-green-600 font-bold text-sm max-md:text-xs">{formatPrice(city.deliver)}</div>
                </div>
                <div>
                  <div className="text-gray-500 max-md:text-xs">{t('cities.return')}</div>
                  <div className="text-rose-500 font-semibold text-sm max-md:text-xs">{formatPrice(city.return)}</div>
                </div>
                <div>
                  <div className="text-gray-500 max-md:text-xs">{t('cities.refusal')}</div>
                  <div className="text-yellow-500 font-semibold text-sm max-md:text-xs">{formatPrice(city.refuse)}</div>
                </div>
                <div>
                  <div className="text-gray-500 max-md:text-xs">{t('cities.exchange')}</div>
                  <div className="text-blue-500 font-semibold text-sm max-md:text-xs">{formatPrice(city.change)}</div>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
  )
}
